// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"root_gvn9t ml-2.5 inline-block leading-none cursor-pointer align-middle sm_align-sub","icon":"icon_Y5-EO"};